module.exports = __webpack_public_path__ + "img/1440.6185bc97.jpg";